import http from '@/service/http'
import findIndex from 'lodash/findIndex'

const save = async (context, obj) => {
  const { verb, transacoesCompraVenda } = obj
  const response = await http[verb]('/transacoesCompraVenda', transacoesCompraVenda)

  if (response !== null) {
    transacoesCompraVenda.id = response.data.data.id
    update(context, { ...transacoesCompraVenda })
    return Promise.resolve()
  }
}

const fetchOne = async (context, id) => {
  const response = await http.get(`/transacoesCompraVenda/${id}`)
  if (response !== null) {
    return Promise.resolve(response.data.data)
  }
}

const fetch = async ({ commit }) => {
  const response = await http.get('/transacoesCompraVenda')
  if (response !== null) {
    const transacoesCompraVenda = response.data
    commit('SET_LIST', transacoesCompraVenda)
  }
}

const update = ({ commit, state }, obj) => {
  const index = findIndex(state.list, { id: obj.id })
  const payload = { transacoesCompraVenda: obj, index }
  commit('SET_ONE', payload)
}

const remove = ({ commit, state }, obj) => {
  return new Promise(async (resolve) => {
    const { id } = obj
    const response = await http.delete(`/transacoesCompraVenda/${id}`)
    const message = response.data.data
    const index = findIndex(state.list, { id })

    if (index > -1) {
      commit('REMOVE_ONE', { index })
    }

    resolve(message)
  })
}

export default {
  fetch,
  fetchOne,
  save,
  update,
  remove
}



// WEBPACK FOOTER //
// ./src/features/admin/venderFichas/store/actions.js